// extracted by mini-css-extract-plugin
var _1 = "BbBqYrBd0y";
var _2 = "raf0a9gKiI";
export { _1 as "disabled", _2 as "root" }
